export const SET_IS_LOADING = "USERS/SET_IS_LOADING";
export const SET_USER_LIST = "USERS/SET_USER_LIST";
export const USER_LIST_ADD_ITEM = "USER_LIST_ADD_ITEM";
export const USER_LIST_UPDATE_ITEM = "USER_LIST_UPDATE_ITEM";
export const USER_LIST_REMOVE_ITEM = "USERS/USER_LIST_REMOVE_ITEM";
export const SET_HISTORIC_ACCESS_LOGS = "SET_HISTORIC_ACCESS_LOGS";
